import { Api_Host } from "../api";

export const getAllRegimenFiscal = () => Api_Host.get('/regimenfiscal/');
